import React, { useState } from 'react';
import './RightSlider.css';
import Gauge from './Gauge';
import architectureWorkflow from '../assets/architecture_workflow.png';


const RightSlider = ({ benefitsContent, tierModelContent, kpiContent,solutionFlowData }) => {
  const [activePanel, setActivePanel] = useState(null);
  // This function handles the click logic
  const handleIconClick = (panelName) => {
    // If the clicked panel is already open, close it.
    if (activePanel === panelName) {
      setActivePanel(null);
    } else {
      // Otherwise, open the clicked panel.
      setActivePanel(panelName);
    }
  };

  return (
    // The onMouseLeave is removed from this wrapper
    <div className="right-slider-wrapper">
      <div 
        className={`slider-panel ${activePanel ? 'visible' : ''}`}
      >
        {/* Add a close button that is always visible when a panel is open */}
        {activePanel && (
          <button className="panel-close-btn" onClick={() => setActivePanel(null)} title="Close Panel">
            &times;
          </button>
        )}

        {activePanel === 'benefits' && (
          <div className="panel-content">
            <h4>Business Value & Outcomes</h4>
            {benefitsContent && benefitsContent.length > 0 ? (
                <ul>
                {benefitsContent.map((point, index) => (
                    <li key={index}>{point}</li>
                ))}
                </ul>
            ) : <p>No benefits data available.</p>}
          </div>
        )}
        {activePanel === 'tierModel' && (
          <div className="panel-content">
            <h4>Agentic Agent Tier Model</h4>
            <div className="tier-model-section">
                <h5>Trigger / Invocation Tier</h5>
                <p>{tierModelContent.trigger}</p>
            </div>
             <div className="tier-model-section">
                <h5>Working Plane / Orchestration Tier</h5>
                <p>{tierModelContent.workingPlane}</p>
            </div>
             <div className="tier-model-section">
                <h5>Memory Tier</h5>
                <p>{tierModelContent.memory}</p>
            </div>
            <div className="tier-model-section">
                <h5>Reasoning Tier</h5>
                <p>{tierModelContent.reasoning}</p>
            </div>
            <div className="tier-model-section">
                <h5>Execution Tier</h5>
                <p>{tierModelContent.execution}</p>
            </div>
          </div>
        )}
       {activePanel === 'architectureWorkflow' && (
          <div className="panel-content">
            <h4 style={{ textAlign: 'center', marginBottom: '12px' }}>
              Architecture Workflow
            </h4>

            <div style={{ textAlign: 'center', overflow: 'visible' }}>
              <img
                src={architectureWorkflow}
                alt="Architecture Workflow"
                className="workflow-image"
              />
            </div>
          </div>
        )}
        {activePanel === 'kpis' && (
          <div className="panel-content">
            <h4>KPI Scorecard</h4>
            {kpiContent && kpiContent.length > 0 ? (
              <div className="gauge-grid-slider">
                {kpiContent.map(kpi => (
                  <Gauge key={kpi.label} {...kpi} />
                ))}
              </div>
            ) : (
              <p>No KPI data available for this agent.</p>
            )}
          </div>
        )}
      </div>

      <div className="right-icon-bar">
        {/* Change onMouseEnter to onClick */}
        <div className="slider-icon" onClick={() => handleIconClick('benefits')} title="Benefits">
          <i className="fas fa-thumbs-up"></i>
        </div>
        
        {kpiContent && kpiContent.length > 0 && (
            <div className="slider-icon" onClick={() => handleIconClick('kpis')} title="KPIs">
                <i className="fas fa-tachometer-alt"></i>
            </div>
        )}
        
        <div className="slider-icon" onClick={() => handleIconClick('tierModel')} title="Tier Model">
          <i className="fas fa-sitemap"></i>
        </div>
        
        {solutionFlowData && solutionFlowData.length>0 && (
          <div className="slider-icon">
            <i
              className="fas fa-project-diagram"
              onClick={() => window.open(architectureWorkflow, "_blank")}
              title="Architecture Workflow"
            ></i>
          </div>
         )}
      </div>
       
    </div>
  );
};

export default RightSlider;